import { Pipe, PipeTransform } from '@angular/core';
import { round } from 'lodash';

@Pipe({
    name: 'formatPercentage',
    standalone: false,
})
export class FormatPercentagePipe implements PipeTransform {
    transform(value: number, precision: number): string {
        let roundedValue = round(value, precision);

        if (value > 0 && roundedValue == 0) {
            const decimalPart = value.toString().split('.')[1];
            const decimalPrecision = decimalPart.split('').findIndex((decimal) => +decimal > 0) + 1;

            roundedValue = round(value, decimalPrecision);
        }

        return `${roundedValue}%`;
    }
}
